// libs
import { createContext, useContext } from 'react';

// defs
import { ToastConfig } from './types';

interface IToastContext {
  showToast: (config: ToastConfig) => void;
}

const EMPTY_FUNC = () => {};

const initialValue: IToastContext = {
  showToast: EMPTY_FUNC,
};

const ToastContext = createContext(initialValue);

export const useToastContext = () => useContext(ToastContext);

export default ToastContext;
